module.exports = __webpack_public_path__ + "img/wambulawae.f763d501.png";